<template>
  <router-view :key="$route.fullPath" />
</template>
<script>
export default {

  setup() {
  },

}
</script>

<style>
@font-face {
  font-family: 'MTNBrighterSans';
  src: url('./assets/Fonts/MTNBrighterSans-Regular.otf') format('opentype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'MTNBrighterSans1';
  src: url('./assets/Fonts/MTNBrighterSans-Medium.otf') format('opentype');
  font-weight: 500;
  font-style: normal;
}

body,
html {
  font-family: 'MTNBrighterSans1', sans-serif !important;
  direction: rtl;
  background: linear-gradient(135deg, #FFC403 0%, #FFC403 50%, #000000 100%);
  min-height: 100vh;
}

.bg-gradient-sudan {
  background: linear-gradient(135deg, #FFC403 0%, #FFC403 50%, #000000 100%) !important;
}
</style>
